import { Injectable, Inject } from '@angular/core';
import { HttpParams,  HttpClient,   HttpRequest } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import 'rxjs/Rx';
import { APP_CONFIG } from '../app.config';

import * as moment from 'moment';
import { Observable } from 'rxjs/Rx';
import { AuthService } from './auth.service';
declare var $: any;

@Injectable()
export class GlobalService {
    resetSearch = new Subject<boolean>();
    insertListings = new Subject();
    onSelectListing = new Subject();

    public element_listing_limit = 0;
    public template: any;

    constructor(
      @Inject(APP_CONFIG) public appConfig,
      private httpClient: HttpClient,
      public authService: AuthService
    ) {}

    httpGetAuthRefresh(provider = 'mydesktop'): Observable<any> {
      const groupid = this.authService.auth.groupid;
      const agentid = this.authService.auth.agentid;

      let url = 'auth';

      if ( provider === 'vaultre' ) {
        const vaultLocation = localStorage.getItem('vaultLocation');

        if ( vaultLocation === 'uk' ) {
          url = 'vaultea';
        } else {
          url = 'vault';
        }
      }

      if ( provider === 'domain' ) {
          url = 'domain';
      }

      let isAdminLink = '/user';
      const isAdminData = localStorage.getItem('isAdmin');

      if ( isAdminData === 'yes' ) {
        isAdminLink = '/admin';
      }

      if ( provider === 'mydesktop' ) {
        isAdminLink = '';
      }

      const req = new HttpRequest(
        'GET',
        this.appConfig.API_ENDPOINT + '/' + url + '/refresh/' + groupid + '/' + agentid + isAdminLink
      );

      return this.httpClient.request<any>(req)
      .map(
        (response: any) => {
          if (response.body) {
            return response.body;
          }
        }
      );
    }
  
}




// WEBPACK FOOTER //
// ./src/app/services/global.service.ts